import React, { useEffect, useRef, useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography, Autocomplete, Radio, RadioGroup, FormControl, Avatar, Checkbox } from '@mui/material';
import { PlusCircle, ArrowLeft, ChevronLeft, User } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import Toastmessage from '../../components/Toast';
import { authApi, formauthApi } from '../../api/api';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

const RequiredLabel = ({ children }) => (
    <>
      {children} <span style={{ color: 'red' }}>*</span>
    </>
  );


export default function CreateMember() {
    const fileInputRef = useRef(null);
    const [membername, setMemberName] = useState('');
    const [relationship, setRelationship] = useState(null);
    const [gender, setGender] = useState('');
    const [selectedYear, setSelectedYear] = useState(null);
    const [deathYear, setDeathYear] = useState(null);
    const [mother, setMother] = useState(null);
    const [father, setFather] = useState(null);
    const [spouse, setSpouse] = useState(null);
    const [tag, setTag] = useState(null);
    const [divorce, setDivorce] = useState(null);
    const [deceased, setDeceased] = useState(null);
    const [notes, setNotes] = useState(null);
    const [active, setActive] = useState(true);
    const [errors, setErrors] = useState({}); // State to hold validation errors
    const [imageURL, setImageURL] = useState(null);
    const [profile, setProfile] = useState(null);
    const [isLoading, setIsloading] = useState(false);



    const [isCheckboxChecked, setIsCheckboxChecked] = React.useState(false);

    const location = useLocation();
    const { treeId } = location.state || {};


    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [motherOptions, setMotherOptions] = useState([]);

    const [fatherOptions, setFatherOptions] = useState([]);

    const [spouseOptions, setSpouseOptions] = useState([]);

    const [isparent, setIsparent] = useState(false);

    const handleChange = (event) => {
        setIsparent(event.target.checked);
    };
    const handleActiveChange = (event) => {
        setActive(event.target.checked);
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageURL(reader.result);
                setProfile(file); // Set the file object in formData
            };
            reader.readAsDataURL(file);
        }
    };

    // Generate an array of the last 150 years
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 150 }, (_, i) => currentYear - i);


    const relationshipOptions = [
        "Great Great Mainfather",
        "Great Great Mainmother",
        "Great Mainfather",
        "Great Mainmother",
        "P.Mainfather",
        "P.Mainmother",
        "Divorce",
        "Dad",
        "Mom",
        "Spouse",
        "Child",
        "Myself",
        "Wife2",
        "First Wife",
        "Child 1",
        "Child 2",
        "Child 3",
        "Brother",
        "Sister",
    ];


    const tagOptions = [
        "deceased",
        "adopted_male",
        "adopted_female",
    ];



    useEffect(() => {
        if (treeId) {
            fetchfather(treeId);
            fetchmotherr(treeId);
            fetchspouse(treeId)
        }
    }, [token, userID, treeId]); // Run effect when token or userID changes


    // Define fetchLocations separately to reuse it
    const fetchfather = async (treeId) => {
        const input_token = 'FATHER_LIST'; // Replace with your actual token
        const apiUrl = 'fathers_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // setRows(data.locations);
                setFatherOptions(data.fatherMembers)
                // setFilteredRows(data.locations); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const fetchmotherr = async (treeId) => {
        const input_token = 'MOTHER_LIST'; // Replace with your actual token
        const apiUrl = 'mothers_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // setRows(data.locations);
                setMotherOptions(data.motherMembers)
                // setFilteredRows(data.locations); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    const fetchspouse = async (treeId) => {
        const input_token = 'SPOUSE_LIST'; // Replace with your actual token
        const apiUrl = 'spouse_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setSpouseOptions(data.fatherMembers)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!membername.trim()) {
            newErrors.familyname = "Member name is required";
        }

        if (!relationship) {
            newErrors.clientname = "Relationship required";
        }

        if (!gender) {
            newErrors.gender = "Gender required";
        }

        if (!selectedYear) {
            newErrors.selectedYear = "Birth year required";
        }
        
        if (deathYear && deathYear < selectedYear) {
            newErrors.deathYear = "Death year cannot be before birth year";
        }

        // if (relationship === "Child") {
        // if (!mother) {
        //     newErrors.mother = "Mother name required";
        // }

        // if (!father) {
        //     newErrors.father = "Father name required";
        // }
        // }

        if (spouse?.name) {
            if (!divorce) {
                newErrors.divorce = "Divorce details required";
            }
        }




        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Exit if validation fails
        }

        const formData = {
            membername,
            relationship: relationship ? relationship.relationship : '',
            gender,
            selectedYear: selectedYear ? selectedYear : '',
            deathYear,
            mother,
            father,
            spouse,
            tag,
            divorce,
            notes,
            active
        };


        const addmemberApi = async () => {
            setIsloading(true)
            const input_token = 'ADD_OR_EDIT_FAMILY_MEMBER';
            const apiUrl = 'add_family_member';

            // Create a FormData object
            const formDataToSend = new FormData();

            formDataToSend.append('family_id', treeId);
            formDataToSend.append('relationship', relationship);
            formDataToSend.append('login_user_id', userID);
            formDataToSend.append('name', membername);
            formDataToSend.append('gender', gender);
            formDataToSend.append('bdate', selectedYear);
            formDataToSend.append('ddate', deathYear);
            formDataToSend.append('notes', notes);
            formDataToSend.append('divorced', divorce);
            // formDataToSend.append('pids', [spouse ? spouse?.id : null]);
            formDataToSend.append('pids', spouse ? spouse.id : null);
            formDataToSend.append('tags', tag);
            formDataToSend.append('mid', mother ? mother.id : null);
            formDataToSend.append('fid', father ? father.id : null);
            formDataToSend.append('is_deceased', isCheckboxChecked ? 1 : 0);
            formDataToSend.append('trust', 0 );
            formDataToSend.append('status', active ? 1 : 0);
            // Append form fields
            if (profile) {
                formDataToSend.append('img', profile);
            }
            try {
                const data = await formauthApi(input_token, formDataToSend, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate('/familytree'), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false)
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false)
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false)
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false)
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addmemberApi()
    };

    return (
        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add New Family Member
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/familytree"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Family List
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <form onSubmit={handleSubmit}>
                    <Box className="sub-header">
                        <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                            <Link to="/familytree" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} /> {/* Add margin for spacing */}
                                Add New Family Member
                            </Link>
                        </Typography>
                        {/* <FormControlLabel
                            control={<Switch checked={active} onChange={handleActiveChange} />}
                            label={
                                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                    Active : {active ? 'Yes' : 'No'}
                                </Typography>
                            }
                        /> */}
                    </Box>

                    <Grid container spacing={4} sx={{ mt: 2 }}>
                        {/* <Grid size={{ xs: 12, md: 12 }} display={'flex'} justifyContent={'end'}>
                            <FormControlLabel
                                control={<Checkbox checked={isparent} onChange={handleChange} />}
                                label="is parent"
                            />
                        </Grid> */}

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Family Member Name</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the family member name"
                                variant="outlined"
                                value={membername}
                                onChange={(e) => setMemberName(e.target.value)}
                                error={!!errors.familyname}
                                helperText={errors.familyname} // Display error message
                                InputProps={{
                                    sx: {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isCheckboxChecked}
                                        onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="is Deceased?"
                                sx={{ mt: 0, color: '#595A63' }}
                            />
                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 2 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>deceased</Typography>
                            <FormControl component="fieldset" error={!!errors.divorce}>
                                <RadioGroup
                                    row
                                    aria-label="deceased"
                                    name="deceased"
                                    value={deceased}
                                    onChange={(event, newValue) => setDeceased(newValue)}
                                >
                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                </RadioGroup>
                                {errors.deceased && (
                                    <Typography variant="caption" color="error">
                                        {errors.deceased}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid> */}

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select Relationship</RequiredLabel></Typography>
                            <Autocomplete
                                options={relationshipOptions}
                                value={relationship || ""}
                                onChange={(event, newValue) => setRelationship(newValue || "")}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Relationship"
                                        variant="outlined"
                                        error={!!errors.clientname}
                                        helperText={errors.clientname} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Gender</RequiredLabel></Typography>
                            <FormControl component="fieldset" error={!!errors.gender}>
                                <RadioGroup
                                    row
                                    aria-label="gender"
                                    name="gender"
                                    value={gender}
                                    onChange={(event, newValue) => setGender(newValue)}
                                >
                                    <FormControlLabel value="female" control={<Radio />} label="Female" />
                                    <FormControlLabel value="male" control={<Radio />} label="Male" />
                                    <FormControlLabel value="other" control={<Radio />} label="Other" />
                                </RadioGroup>
                                {errors.gender && (
                                    <Typography variant="caption" color="error">
                                        {errors.gender}
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography>member Logo</Typography>
                            <Box display="flex" flexDirection="row" alignItems="center" gap={3}>
                                <Avatar
                                    variant="rounded"
                                    src={imageURL || ""}
                                    sx={{ width: 100, height: 100, mb: 1 }}
                                />
                                <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                                    <input
                                        type="file"
                                        accept="image/jpeg, image/png"
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                        onChange={handleFileUpload}
                                    />
                                    <Button sx={{ backgroundColor: 'var(--back-button)', color: "var(--back-color)", fontWeight: "600", padding: "10px 20px" }} onClick={handleButtonClick}>
                                        Upload Image
                                    </Button>
                                    <Typography variant="caption" sx={{ mt: 1 }}>
                                        JPG or PNG no larger than 5 MB
                                    </Typography>
                                    {/* Display image error */}
                                    {errors.profile_image && (
                                        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                                            {errors.profile_image}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select Birth Year</RequiredLabel></Typography>
                            <Autocomplete
                                options={yearOptions}
                                getOptionLabel={(option) => option}
                                value={selectedYear}
                                onChange={(event, newValue) => setSelectedYear(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select year"
                                        variant="outlined"
                                        error={!!errors.selectedYear}
                                        helperText={errors.selectedYear} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Death Year</Typography>
                            <Autocomplete
                                options={yearOptions}
                                getOptionLabel={(option) => option}
                                value={deathYear}
                                onChange={(event, newValue) => setDeathYear(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select year"
                                        variant="outlined"
                                        error={!!errors.deathYear}
                                        helperText={errors.deathYear} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Mother</Typography>
                            <Autocomplete
                                options={motherOptions}
                                getOptionLabel={(option) => `${option.name}`}
                                value={mother}
                                onChange={(event, newValue) => setMother(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select mother"
                                        variant="outlined"
                                        error={!!errors.mother}
                                        helperText={errors.mother} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Father</Typography>
                            <Autocomplete
                                options={fatherOptions}
                                getOptionLabel={(option) => `${option.name}`}
                                value={father}
                                onChange={(event, newValue) => setFather(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select father"
                                        variant="outlined"
                                        error={!!errors.father}
                                        helperText={errors.father} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Spouse</Typography>
                            <Autocomplete
                                options={spouseOptions}
                                getOptionLabel={(option) => `${option.name}`}
                                value={spouse}
                                onChange={(event, newValue) => setSpouse(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Spouse"
                                        variant="outlined"
                                        error={!!errors.spouse}
                                        helperText={errors.spouse} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Tag</Typography>
                            <Autocomplete
                                options={tagOptions}
                                getOptionLabel={(option) => option}
                                value={tag}
                                onChange={(event, newValue) => setTag(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select tag"
                                        variant="outlined"
                                        error={!!errors.tag}
                                        helperText={errors.tag} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        {spouse?.name&& (
                            <Grid size={{ xs: 12, md: 3 }}>
                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Divorced</RequiredLabel></Typography>
                                <FormControl component="fieldset" error={!!errors.divorce}>
                                    <RadioGroup
                                        row
                                        aria-label="divorce"
                                        name="divorce"
                                        value={divorce}
                                        onChange={(event, newValue) => setDivorce(newValue)}
                                    >
                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="no" control={<Radio />} label="No" />
                                    </RadioGroup>
                                    {errors.divorce && (
                                        <Typography variant="caption" color="error">
                                            {errors.divorce}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                        )}




                        <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Additional Notes</Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter additional notes"
                                variant="outlined"
                                multiline
                                rows={4} // Number of rows for the textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                error={!!errors.notes}
                                helperText={errors.notes} // Display error message if any
                                InputProps={{
                                    sx: {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                        </Grid>


                        <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={isLoading}
                                startIcon={<PlusCircle size={20} />}
                                 className='btn-theme-button'
                            >
                                Add New Family Member
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    );
}
